<ng-select [class]="selectClass" [searchFn]="searchFn" [groupBy]="shouldGroup? 'group' : null" [hideSelected]="true" [readonly]="readonly" [appendTo]="appendTo" [clearable]="clearable" [items]="data" bindLabel="name" [placeholder]="placeholder" [searchable]="true" [multiple]="multiple" [closeOnSelect]="closeOnSelect" [hideSelected]="hideSelected" [formControl]="control" (open)="onOpen()" (close)="onClose()" (change)="onSelectionChange($event)">
    <!-- <ng-template ng-option-tmp let-item="item">
        {{item?.name}}
    </ng-template>

    <ng-template ng-label-tmp let-item="item" let-clear="clear">
        {{item?.name}}
    </ng-template> -->
</ng-select>

@if(showView){
    <wb-button-icon size="Medium" [disabled]="isDisabled" [loading]="isBusy" iconLeft="fa-regular fa-eye" (onClick)="onView()" />
}
@if(showDownload){
    <wb-button-icon size="Medium" [disabled]="isDisabled" iconLeft="fa-regular fa-arrow-down-to-bracket" (onClick)="downloadClicked()" />
}